export default function defined(...args) {
    //console.log('>>> defined')
    let ret = true;
    args.forEach(arg => ret = ret && typeof arg !== 'undefined');
    return ret;
}